// if adding a new event - don't forget to add it to eventregistry.ts
export var BiEventType;
(function (BiEventType) {
    BiEventType[BiEventType["CLICK_REPORT_BUTTON"] = 20] = "CLICK_REPORT_BUTTON";
    BiEventType[BiEventType["BACK_TO_TOP"] = 97] = "BACK_TO_TOP";
    BiEventType[BiEventType["SCROLL_TO_LOAD_MORE"] = 98] = "SCROLL_TO_LOAD_MORE";
    BiEventType[BiEventType["PAGEVIEW"] = 99] = "PAGEVIEW";
    BiEventType[BiEventType["THUMB_CLICK"] = 100] = "THUMB_CLICK";
    BiEventType[BiEventType["USERNAME_CLICK"] = 101] = "USERNAME_CLICK";
    BiEventType[BiEventType["THUMB_FAVE"] = 102] = "THUMB_FAVE";
    BiEventType[BiEventType["THUMB_CLICK_LOVE_METER"] = 103] = "THUMB_CLICK_LOVE_METER";
    BiEventType[BiEventType["THUMB_SELECT_LOVE"] = 104] = "THUMB_SELECT_LOVE";
    BiEventType[BiEventType["THUMB_CLICK_COMMENT"] = 105] = "THUMB_CLICK_COMMENT";
    BiEventType[BiEventType["SEE_ALL_CLICK"] = 106] = "SEE_ALL_CLICK";
    BiEventType[BiEventType["USERNAME_HOVER_TO_OPEN"] = 107] = "USERNAME_HOVER_TO_OPEN";
    BiEventType[BiEventType["CAROUSEL_ARROW_CLICK"] = 108] = "CAROUSEL_ARROW_CLICK";
    BiEventType[BiEventType["CONTENT_NAVBAR_CLICK"] = 120] = "CONTENT_NAVBAR_CLICK";
    BiEventType[BiEventType["SORT_TYPE_SELECT"] = 122] = "SORT_TYPE_SELECT";
    BiEventType[BiEventType["FACET_CONTROL_TOGGLE"] = 124] = "FACET_CONTROL_TOGGLE";
    BiEventType[BiEventType["FACET_SELECT"] = 125] = "FACET_SELECT";
    BiEventType[BiEventType["PROFILE_NAV_BAR"] = 200] = "PROFILE_NAV_BAR";
    BiEventType[BiEventType["SEND_NOTE_CLICK"] = 273] = "SEND_NOTE_CLICK";
    BiEventType[BiEventType["GIFT_CLICK"] = 274] = "GIFT_CLICK";
    BiEventType[BiEventType["GIFT_SELECT_CLICK"] = 275] = "GIFT_SELECT_CLICK";
    BiEventType[BiEventType["NAVIGATION_ARROW_CLICK"] = 300] = "NAVIGATION_ARROW_CLICK";
    BiEventType[BiEventType["THEATRE_MODE"] = 301] = "THEATRE_MODE";
    BiEventType[BiEventType["FULLSCREEN_MODE"] = 302] = "FULLSCREEN_MODE";
    BiEventType[BiEventType["ZOOM_MODE"] = 303] = "ZOOM_MODE";
    BiEventType[BiEventType["BACK_TO_CLICK"] = 304] = "BACK_TO_CLICK";
    BiEventType[BiEventType["ADD_TO_COLLECTION_CLICK"] = 330] = "ADD_TO_COLLECTION_CLICK";
    BiEventType[BiEventType["ADD_TO_COLLECTION_DONE_CLICK"] = 331] = "ADD_TO_COLLECTION_DONE_CLICK";
    BiEventType[BiEventType["CLICK_DOWNLOAD_BUTTON"] = 350] = "CLICK_DOWNLOAD_BUTTON";
    BiEventType[BiEventType["DOWNLOAD_NOW_CLICK"] = 351] = "DOWNLOAD_NOW_CLICK";
    BiEventType[BiEventType["CLICK_SHARE"] = 355] = "CLICK_SHARE";
    BiEventType[BiEventType["CLICK_SOCIAL_SHARE"] = 356] = "CLICK_SOCIAL_SHARE";
    BiEventType[BiEventType["CLICK_COPY"] = 357] = "CLICK_COPY";
    BiEventType[BiEventType["BUY_CLICK"] = 360] = "BUY_CLICK";
    BiEventType[BiEventType["WATCH_AUTHOR"] = 380] = "WATCH_AUTHOR";
    BiEventType[BiEventType["FACET_CLICK"] = 390] = "FACET_CLICK";
    BiEventType[BiEventType["TAG_CLICK"] = 391] = "TAG_CLICK";
    BiEventType[BiEventType["WATCH_SECTION_SELECT"] = 400] = "WATCH_SECTION_SELECT";
    BiEventType[BiEventType["TOP_NAV_CLICK"] = 700] = "TOP_NAV_CLICK";
    BiEventType[BiEventType["TOP_NAV_MENU_CLICK"] = 702] = "TOP_NAV_MENU_CLICK";
    BiEventType[BiEventType["CLOSE_BANNER_AD"] = 8005] = "CLOSE_BANNER_AD";
    BiEventType[BiEventType["VIEW_MODE_SELECT"] = 620] = "VIEW_MODE_SELECT";
})(BiEventType || (BiEventType = {}));
export var BiDataHook;
(function (BiDataHook) {
    BiDataHook["CODEBLOCK_BUTTON"] = "codeBlockButton";
    BiDataHook["VIDEO_PLAYER"] = "videoPlayer";
    BiDataHook["DROPDOWN_LAYOUT_OPTIONS"] = "dropdown-layout-options";
    BiDataHook["TOP_NAV"] = "top-nav";
    BiDataHook["DEVIATION_NAV"] = "deviation-nav";
    BiDataHook["FILTER_NAV"] = "filter-nav";
    BiDataHook["CONTENT_ROW_IDX"] = "content-row";
    BiDataHook["BROWSE_ALL_CONTENT"] = "all-content";
    BiDataHook["DEVIATION_ART_STAGE"] = "art-stage";
    BiDataHook["DEVIATION_ACTION_BAR"] = "action-bar";
    BiDataHook["DEVIATION_ADD_TO_FAVES_POPUP"] = "fave-pop-up";
    BiDataHook["DEVIATION_META"] = "deviation_meta";
    BiDataHook["DEVIATION_TITLE"] = "deviation_title";
    BiDataHook["DEVIATION_COMMENTS_COUNTER"] = "comments_counter";
    BiDataHook["DEVIATION_FAVES_COUNTER"] = "faves_counter";
    BiDataHook["DEVIATION_GROUPS_COUNTER"] = "group_counter";
    BiDataHook["DEVIATION_SHARE_BUTTON"] = "share_button";
    BiDataHook["DEVIATION_WATCH_BUTTON"] = "watch_button";
    BiDataHook["DEVIATION_GRID_ITEM"] = "deviation-grid";
    BiDataHook["PROFILE_NAV"] = "profile-nav";
    BiDataHook["PROFILE_GALLECTION_FOLDER"] = "gallection-folder";
    BiDataHook["PROFILE_GALLECTION_FOLDER_ITEM"] = "gallection_folder_";
    BiDataHook["PROFILE_GALLECTION_FOLDER_CHOOSER"] = "gallection_chooser";
    BiDataHook["PROFILE_GALLECTION_FOLDER_DROPDOWN"] = "gallection_dropdown";
    BiDataHook["FAVES_POPUP"] = "fave_pop_up";
    BiDataHook["FAVES_POPUP_MESSAGE"] = "fav_pop_up_message";
})(BiDataHook || (BiDataHook = {}));
//# sourceMappingURL=constants.js.map